import { render } from "./WorkSolutionsIcon.vue?vue&type=template&id=05373314"
import script from "./WorkSolutionsIcon.vue?vue&type=script&lang=js"
export * from "./WorkSolutionsIcon.vue?vue&type=script&lang=js"

import exportComponent from "/home/tantonj/Documents/GitHub/TantonSoftwareSolutions/tantonsoftwaresolutions/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__